import { createContext } from 'react';
import { AuthContextProvider } from '../interfaces/auth.interface';

export const AuthContext = createContext<AuthContextProvider>({
  permissions: null,
  loggedInUser: {},
  token: '',
  isSystemAdmin: false,
  theme: 'light',
  exception: '',
  loading: 'false',
  roleChanged: false,
  moduleConfig: {},
  logout: () => { },
  setLoggedInUser: () => { },
  setToken: () => { },
  setPermissions: () => { },
  setIsSystemAdmin: () => { },
  setTheme: () => { },
  setException: () => { },
  setLoading: () => { },
  setRoleChanged: () => { },
  setModuleConfig: () => { },
});
